"use client"

import {GenMetaTitle, SiteDesc, SiteKeywords} from "@/lib/const";
import {logError} from "@/lib/utils";

export const metadata = {
    title: GenMetaTitle('Error'),
    description: SiteDesc,
    keywords: SiteKeywords,
}


export default function Error({error, reset}) {
    logError(`Error: ${error}`)
    return (
        <div className="flex-grow flex items-center justify-center p-4">
            <div className="text-center bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-auto">
                <h2 className="text-2xl font-bold mb-4">出错了！</h2>
                <p className="text-gray-600 mb-6">我们很抱歉给您带来了不便，请稍后再试。</p>
                <button
                    onClick={() => window.location.href = '/'}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
                >
                    回到首页
                </button>
            </div>
        </div>
    );
}
